export const environment = {
  production: true,
  serviceUrl: 'https://lndservice-test.ustechsupplierportal.com/',
  instance: 'LND'
};
